//types
import type { ImageDataType } from "@adjust/libs/types";

function isUnoptimized(image?: ImageDataType | null) {
  switch (image?.type) {
    default:
    case "STATIC":
      return false;
    case "EXTERNAL":
      return true;
  }
}

export default isUnoptimized;
